<script setup>
import { userAllowed } from "@/functions";
import { user } from "@/store";
import OfModalBlock from "@dk.onlinefundraising/vue-utils/src/utils/OfModalBlock.vue";
import { ref, defineProps, computed } from "vue";

const props = defineProps({
    user: Object,
})

const userData = ref(props.user);

const formEnabled = computed(() => {
    return userAllowed('UPDATE_USER') || userData.value.userGuid == user.value.guid
})
</script>
<template>
    <OfModalBlock>
        <template #block-content>
            <div class="control-input">

                <label for="name">
                    Name
                </label>

                <input v-model="userData.name" type="text" id="name" required="required" :disabled="!formEnabled">

            </div>

            <div class="control-input" v-if="userAllowed('UPDATE_USER')">

                <label for="role">
                    Role
                </label>

                <select v-model="userData.role" id="role" required="required" :disabled="!formEnabled">
                    <option :value="undefined" disabled>Select user</option>
                    <option value="JuniorAgent">Junior agent</option>
                    <option value="SeniorAgent">Senior agent</option>
                    <option value="AgencyManager">Manager</option>
                </select>

            </div>

            <div class="control-input">

                <label for="email">
                    Email
                </label>

                <input v-model="userData.email" type="text" id="email" required="required" :disabled="!!userData.userGuid">

            </div>

            <div class="control-input">

                <label for="externalId">
                    External ID
                </label>

                <input v-model="userData.externalId" type="text" id="externalId" :disabled="!formEnabled">

            </div>
        </template>
    </OfModalBlock>
</template>